<template>
  <form @submit.prevent="addAddress()">

    <div class="mb-3">
      <label>Tarix *</label>
      <div class="input-group">
        <select class="form-control" v-model="selectedDay" required>
          <option v-for="d in 31" :key="d" :value="d">{{ d }}</option>
        </select>
        <select class="form-control" v-model="selectedMonth" required>
          <option :value="1">Yanvar</option>
          <option :value="2">Fevral</option>
          <option :value="3">Mart</option>
          <option :value="4">Aprel</option>
          <option :value="5">May</option>
          <option :value="6">İyun</option>
          <option :value="7">İyul</option>
          <option :value="8">Avqust</option>
          <option :value="9">Sentyabr</option>
          <option :value="10">Oktyabr</option>
          <option :value="11">Noyabr</option>
          <option :value="12">Dekabr</option>
        </select>
      </div>
    </div>
    <div class="mb-3">
      <label>Başlıq *</label>
      <input class="form-control" v-model="name" required>
    </div>
    <div class="mb-3">
      <label>Əlavə qeyd *</label>
      <textarea class="form-control" v-model="description"></textarea>
    </div>
    <div class="mb-3">
      <button class="btn btn-success btn-lg">
        Əlavə et
      </button>
    </div>
  </form>
</template>

<script>
import {mapState} from 'vuex';
import {addNewSpecialDay} from "@/repositories/UserRepository";

export default {
  data() {
    return {
      selectedDay: 1,
      selectedMonth: 1,
      name: '',
      description: '',
    };
  },
  computed: {
    ...mapState({
      loading: state => state.app.loading,
      user: state => state.auth.user,
      token: state => state.auth.token,
    }),
  },
  methods: {
    addAddress() {


      addNewSpecialDay(this.token, this.name, this.description, this.selectedMonth, this.selectedDay).then(data => {
        if (data.code === 200) {
          this.$emit('dayCreated', data.id)

          this.name = '';
          this.description = '';
          this.selectedMonth = 0;
          this.selectedDay = 0;

        } else {
          alert("Error " + data.code + "; " + data.message);
        }
      });

    },
  },
  emits: ['addressCreated'],
  created() {

  }
}
</script>
